/* eslint-disable no-unused-vars */
// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIIcon from '@ancert/aui-icon';
import AUIButton from '@ancert/aui-button';
import AUIEllipsis from '@ancert/aui-ellipsis';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import downloadFile from '../../utils/downloadFilesUniversal';
import ValidacionMovil from '../../components/ValidacionMovil';
import { getCSV, checkReno, getValidacion, downloadSignedCopy } from '../../services/csv.service';
import {
  ModalPDF,
  ModalErrorServicio,
  ModalErrorGenerico,
  ModalAyuda,
  ModalValidacionFirma,
  ModalErrorValidacion,
  ModalAdvertenciaDescarga,
} from './modales';

import './Home.scss';
import ModalManuales from './modales/ModalManuales/ModalManuales';

// Api key === 6LfrKV4oAAAAAGYO_UtooajJupiAiqc3nC231kgg
/**
 * @component
 * @returns {React.ReactElement} - Devuelve un componente
 */
const Home = () => {
  const captchaRef = useRef(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [renoIp, setRenoIp] = useState(false);
  const [hasUnidos, setHasUnidos] = useState(false);
  const schema = yup.object().shape({});
  const { control, formState, watch, setValue, getValues } = useForm({
    defaultValues: {
      descripcion: undefined,
    },
    resolver: yupResolver(schema),
    mode: 'onSubmit',
  });
  const [recaptcha, setRecaptcha] = useState(null);
  const [dataModal, setDataModal] = useState('');
  const [errorService, setErrorService] = useState(false);
  const [genericError, setGenericError] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [showValidationErrorModal, setShowValidationErrorModal] = useState(false);
  const [showCSVResultadomovil, setShowCSVResultadoMovil] = useState(false);
  const [showManualesModal, setShowManualesModal] = useState(false);
  const [showDownloadWarningModal, setShowDownloadWarningModal] = useState(false);
  const [validationLoading, setValidationLoading] = useState(false);
  const [urlValidacion, setUrlValidacion] = useState('');
  const [urlDescargaCopiaFirmada, setUrlDescargaCopiaFirmada] = useState('');
  const [validationData, setValidationData] = useState(null);
  const history = useHistory();

  // @ts-ignore
  const watchCSV = watch('csv');
  const submit = async () => {
    if (!getValues().csv) return;

    const isMobileDevice = () =>
      typeof navigator !== 'undefined' &&
      /android|iphone|ipad|ipod|opera mini|iemobile|mobile/i.test(navigator.userAgent.toLowerCase());
    try {
      setLoading(true);
      let header = {};
      if (!renoIp) {
        header = { recaptcha };
      }

      const csvFromQR = history?.location?.search
        ? history?.location?.search
            .split('&')
            .find((opt) => opt.includes('csv'))
            .split('=')[1]
        : '';

      const { data, status } = await getCSV(watchCSV || csvFromQR, false, header);

      if (status === 200) {
        if (data?.codigoError === 'E2000') {
          setErrorService(true);
          return;
        }

        setHasUnidos(data?.urlUnidos);
        setUrlValidacion(data?.urlValidacion);
        setUrlDescargaCopiaFirmada(data?.urlDescargaCopiaFirmada);

        if (isMobileDevice()) {
          setShowCSVResultadoMovil(true);
          setDataModal(data?.url);
        } else {
          setDataModal(data?.url);
          setOpenModal(true);
        }
      } else if (status === 400) {
        setErrorService(true);
      } else {
        setGenericError(true);
      }
    } catch (error) {
      setGenericError(true);
    } finally {
      if (!renoIp) {
        captchaRef?.current?.reset();
      }
      setValue('csv', '');
      setButtonDisabled(true);
      setLoading(false);
    }
  };

  // Servicio para comprobar las ips reno actuales y deshabilitar el captcha
  const isRenoIp = async () => {
    try {
      const { data, status } = await checkReno();
      if (status === 200) {
        setRenoIp(data);
        if (data && getValues().csv) {
          submit();
        }
      }
    } catch (error) {
      setErrorService(true);
    }
    setButtonDisabled(true);
  };
  useEffect(() => {
    if (history.location.search) {
      const csvFromQR = history?.location?.search
        ? history?.location?.search
            .split('&')
            .find((opt) => opt.includes('csv'))
            .split('=')[1]
        : '';
      setValue('csv', csvFromQR);
    }
    isRenoIp();
  }, []);

  useEffect(() => {
    if (renoIp && getValues().csv) {
      setButtonDisabled(false);
    } else if (recaptcha && watchCSV) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [renoIp, watchCSV, recaptcha]);

  // Función para mostrar ayuda
  const handleShowHelp = () => {
    setShowHelpModal(true);
  };

  // Función para extraer código CSV de una URL
  const extractCsvFromUrl = (url) => {
    if (!url) return null;
    // Extraer la parte después de /pe/validar/ o /pe/descargar-copia/
    const match = url.match(/\/pe\/(?:validar|descargar-copia)\/(.+)$/);
    return match ? match[1] : null;
  };

  // Función para validar firma
  const handleValidateSignature = async () => {
    setValidationLoading(true);
    try {
      const csvCode = extractCsvFromUrl(urlValidacion);
      if (!csvCode) {
        setShowValidationErrorModal(true);
        return;
      }

      let header = {};
      if (!renoIp) {
        header = { recaptcha };
      }

      const { data, status } = await getValidacion(csvCode, header);
      if (status === 200) {
        // Verificar si la validación es exitosa
        const isValidSignature =
          !data.contenidoAlterado &&
          !data.certificadoCaducado &&
          !data.certificadoRevocado &&
          data.certificadoCa &&
          data.nombreFirmante &&
          data.fechaFirma &&
          data.fechaValidacion;

        if (isValidSignature) {
          setValidationData(data);
          setShowValidationModal(true);
        } else {
          setShowValidationErrorModal(true);
        }
      } else {
        setShowValidationErrorModal(true);
      }
    } catch (error) {
      console.error('Error validating signature:', error);
      setShowValidationErrorModal(true);
    } finally {
      setValidationLoading(false);
    }
  };

  // Función para descargar documento unidos
  const handleDownloadDocument = async () => {
    await downloadFile(hasUnidos);
  };

  // Función para mostrar modal de advertencia antes de descargar
  const handleDownloadSignedCopy = () => {
    setShowDownloadWarningModal(true);
  };

  // Función para confirmar y proceder con la descarga
  const handleConfirmDownload = async () => {
    setShowDownloadWarningModal(false);
    await downloadFile(urlDescargaCopiaFirmada);
  };

  // Función para cancelar la descarga
  const handleCancelDownload = () => {
    setShowDownloadWarningModal(false);
  };

  const descargarJustificanteMobil = async () => {
    if (!dataModal) return;
    window.open(dataModal, '_blank');
  };

  // Función para cerrar el modal PDF y resetear estados
  const handleClosePDFModal = () => {
    setOpenModal(false);
    setDataModal(undefined);
    setButtonDisabled(true);
    setRecaptcha(undefined);
  };

  const { t } = useTranslation();

  return (
    <div className="page">
      {showCSVResultadomovil ? (
        <ValidacionMovil
          onClose={() => setShowCSVResultadoMovil(false)}
          handleValidateSignature={handleValidateSignature}
          handleDownloadDocument={handleDownloadSignedCopy}
          descargarJustificanteMobil={descargarJustificanteMobil}
          handleShowHelp={handleShowHelp}
          validationLoading={validationLoading}
          urlDescargaCopiaFirmada={urlDescargaCopiaFirmada}
          dataModal={dataModal}
        />
      ) : (
        <div className="container">
          <div className="title">
            <span>{t('title')}</span>{' '}
            <AUIIcon className="pointer" icon="helpOutline" color="blue" onClick={() => setShowManualesModal(true)} />
          </div>
          <div className="text">
            {t('desc')}
              </div>
          <AUIInputTextField name="csv" placeholder={t('placeholderCSV')} controlRef={control} errors={formState.errors} />
          {!renoIp && (
            <ReCAPTCHA
              className="captcha"
              ref={captchaRef}
              sitekey="6LfrKV4oAAAAAGYO_UtooajJupiAiqc3nC231kgg"
              type="image"
              onChange={(value) => {
                if (!openModal) {
                  setRecaptcha(value);
                }
              }}
            />
          )}
          <AUIButton
            disabled={buttonDisabled}
            className="button-consultar"
            label={t('validateButton')}
            mode="primary"
            onClick={submit}
            loading={loading}
          />
          <ModalPDF
            show={openModal}
            onClose={handleClosePDFModal}
            dataModal={dataModal}
            hasUnidos={hasUnidos}
            urlDescargaCopiaFirmada={urlDescargaCopiaFirmada}
            onShowHelp={handleShowHelp}
            onValidateSignature={handleValidateSignature}
            onDownloadDocument={handleDownloadDocument}
            onDownloadSignedCopy={handleDownloadSignedCopy}
            validationLoading={validationLoading}
          />
        </div>
      )}

      <ModalErrorServicio show={errorService} onClose={() => setErrorService(false)} />

      <ModalErrorGenerico show={genericError} onClose={() => setGenericError(false)} />

      <ModalAyuda show={showHelpModal} onClose={() => setShowHelpModal(false)} />

      <ModalValidacionFirma
        show={showValidationModal}
        onClose={() => setShowValidationModal(false)}
        validationData={validationData}
      />

      <ModalErrorValidacion show={showValidationErrorModal} onClose={() => setShowValidationErrorModal(false)} />

      <ModalAdvertenciaDescarga
        show={showDownloadWarningModal}
        onClose={handleCancelDownload}
        onConfirm={handleConfirmDownload}
      />

      <ModalManuales
        show={showManualesModal}
        onClose={() => setShowManualesModal(false)}
        documents={[
          {
            name: <AUIEllipsis content="Guía de Verificación de copia autorizada electrónica.pdf" />,
            link: 'https://portalnotarial.es/portal/documents/20182/127783/Gu%C3%ADa+de+Validaci%C3%B3n+de+copia+autorizada+electr%C3%B3nica.pdf/11ce252a-d9b1-4e4c-832a-9d75abe80d9d',
          },
        ]}
      />
    </div>
  );
};

export default Home;
